// Меню собирается из единого описания разделов (routes.tsx), чтобы пункты и
// гард маршрутов не расходились. Правьте разделы там, а не здесь.

import { buildMenu } from './routes';

export type { MenuDivider, MenuEntry, MenuItemBase } from '../types/menu';

export const mainMenu = buildMenu();
